const assess = {
  namespaced: true,
  state: () => {
    return {
      // 评估id
      assessId: '',
      // 项目id
      projectId: '',
      // 评估类型
      assessType: ''
    };
  },
  mutations: {
    SET_PROJECT_ID(state, id) {
      state.projectId = id;
    },
    SET_ASSESS_ID(state, id) {
      state.assessId = id;
    },
    SET_ASSESS_TYPE(state, type) {
      state.assessType = type;
    }
  }
};

export default assess;



// WEBPACK FOOTER //
// ./src/store/modules/assess.js